module.exports = __webpack_public_path__ + "img/uploadfild.2a588f41.png";